// import React, { useEffect } from 'react'
// import { LinkContainer } from 'react-router-bootstrap'
// import { Table, Button } from 'react-bootstrap'
// import { useDispatch, useSelector } from 'react-redux'
// import Message from '../components/Message'
// import Loader from '../components/Loader'
// import { listUsers, deleteUser } from '../actions/userActions'

// const UserListScreen = ({ history }) => {
//   const dispatch = useDispatch()

//   const userList = useSelector((state) => state.userList)
//   const { loading, error, users } = userList

//   const userLogin = useSelector((state) => state.userLogin)
//   const { userInfo } = userLogin

//   const userDelete = useSelector((state) => state.userDelete)
//   const { success: successDelete } = userDelete

//   useEffect(() => {
//     if (userInfo && userInfo.isAdmin) {
//       dispatch(listUsers())
//     } else {
//       history.push('/login')
//     }
//   }, [dispatch, history, successDelete, userInfo])

//   const deleteHandler = (id) => {
//     if (window.confirm('Are you sure')) {
//       dispatch(deleteUser(id))
//     }
//   }

//   return (
//     <>
//       <h1>Users</h1>
//       {loading ? (
//         <Loader />
//       ) : error ? (
//         <Message variant='danger'>{error}</Message>
//       ) : (
//         <Table striped bordered hover responsive className='table-sm'>
//           <thead>
//             <tr>
//               <th>ID</th>
//               <th>FIRST NAME</th>
//               <th>LAST NAME</th>
//               <th>USERNAME</th>
//               <th>EMAIL</th>
//               <th>ADMIN</th>
//               <th></th>
//             </tr>
//           </thead>
//           <tbody>
//             {users.map((user) => (
//               <tr key={user._id}>
//                 <td>{user._id}</td>
//                 <td>{user.firstName}</td>
//                 <td>{user.lastName}</td>
//                 <td>{user.username}</td>
//                 <td>
//                   <a href={`mailto:${user.email}`}>{user.email}</a>
//                 </td>
//                 <td>
//                   {user.isAdmin ? (
//                     <i className='fas fa-check' style={{ color: 'green' }}></i>
//                   ) : (
//                     <i className='fas fa-times' style={{ color: 'red' }}></i>
//                   )}
//                 </td>
//                 <td>
//                   <LinkContainer to={`/admin/user/${user._id}/edit`}>
//                     <Button variant='light' className='btn-sm'>
//                       <i className='fas fa-edit'></i>
//                     </Button>
//                   </LinkContainer>
//                   <Button
//                     variant='danger'
//                     className='btn-sm'
//                     onClick={() => deleteHandler(user._id)}
//                   >
//                     <i className='fas fa-trash'></i>
//                   </Button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </Table>
//       )}
//     </>
//   )
// }

// export default UserListScreen



import React, { useEffect, useState } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { Table, Button, Row, Col, Card } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Message from '../components/Message';
import Loader from '../components/Loader';
import { listUsers, deleteUser, getUsersCount } from '../slices/userSlice';
import UserTableFilters from '../components/UserTableFilters';
import Meta from '../components/Meta';
import StepUpPasswordModal from '../components/StepUpPasswordModal';
import { requestStepUpToken } from '../utils/stepUp';

const UserListScreen = ({ history }) => {
  const dispatch = useDispatch();

  // Use correct user slice:
  const userState = useSelector((state) => state.user);
  const { userInfo, loading, error, userList, usersCount, loadingUsersCount, errorUsersCount } = userState;

  // Filters state
  const initialFilters = { id: '', first: '', last: '', username: '', email: '', admin: '' };
  const [rawFilters, setRawFilters] = useState(initialFilters);
  const [filters, setFilters] = useState(initialFilters);

  // Debounce filter updates
  useEffect(() => {
    const t = setTimeout(() => setFilters(rawFilters), 300);
    return () => clearTimeout(t);
  }, [rawFilters]);

  // Responsive viewport logic
  const [viewportWidth, setViewportWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1024);
  useEffect(() => {
    const handleResize = () => setViewportWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const isMobile = viewportWidth <= 991; // broaden mobile card threshold for better mid-size responsiveness
  const shortId = (id = '') => (id ? id.slice(-6) : '');

  useEffect(() => {
    if (userInfo && userInfo.isAdmin) {
      dispatch(listUsers());
      dispatch(getUsersCount());
    } else {
      history.push('/login');
    }
  }, [dispatch, history, userInfo]);

  // Admin account deletion is step-up-gated — re-confirm password first.
  const [pendingDeleteId, setPendingDeleteId] = useState(null);
  const [stepUpLoading, setStepUpLoading] = useState(false);
  const [stepUpError, setStepUpError] = useState('');

  const deleteHandler = (id) => {
    if (window.confirm('Are you sure?')) {
      setStepUpError('');
      setPendingDeleteId(id);
    }
  };

  const handleStepUpConfirm = async (password) => {
    setStepUpLoading(true);
    setStepUpError('');
    try {
      const stepUpToken = await requestStepUpToken(password, userInfo?.token);
      const id = pendingDeleteId;
      setPendingDeleteId(null);
      dispatch(deleteUser({ id, stepUpToken }));
    } catch (e) {
      setStepUpError(e.message);
    } finally {
      setStepUpLoading(false);
    }
  };

  // Filtering logic
  const txt = (v) => (v || '').toLowerCase().trim();
  const filteredUsers = (userList || []).filter((u) => {
    const f = filters;
    if (f.id && !txt(u._id).includes(txt(f.id))) return false;
    if (f.first && !txt(u.firstName).includes(txt(f.first))) return false;
    if (f.last && !txt(u.lastName).includes(txt(f.last))) return false;
    if (f.username && !txt(u.username).includes(txt(f.username))) return false;
    if (f.email && !txt(u.email).includes(txt(f.email))) return false;
    if (f.admin === 'yes' && !u.isAdmin) return false;
    if (f.admin === 'no' && u.isAdmin) return false;
    return true;
  });

  return (
    <>
  <Meta title='Admin — Users — The Lotustor' robots='noindex,follow' />
      <h1>Users</h1>
      <UserTableFilters
        value={rawFilters}
        onChange={setRawFilters}
        onClear={() => setRawFilters(initialFilters)}
      />
      <p className='small text-muted mb-2'>Showing {filteredUsers.length} of {(userList || []).length}</p>

      {/* Admin card showing total users */}
      <Row className='mb-3'>
        <Col md={3} sm={6} xs={12}>
          <Card className='text-center'>
            <Card.Body>
              <Card.Title>Total Users</Card.Title>
              {loadingUsersCount ? (
                <Loader />
              ) : errorUsersCount ? (
                <Message variant='danger'>{errorUsersCount}</Message>
              ) : (
                <h2 style={{ margin: 0 }}>{usersCount}</h2>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {loading ? (
        <Loader />
      ) : error ? (
        <Message variant='danger'>{error}</Message>
      ) : (
        <Table
          striped
          bordered
          hover
          responsive
            className={`table-sm table-users ${isMobile ? 'mobile-mode' : ''}`}
          aria-label='Users list'
        >
          {!isMobile && (
            <thead>
              <tr>
                <th>ID</th>
                <th>NAME</th>
                <th>USERNAME</th>
                <th>EMAIL</th>
                <th>ADMIN</th>
                <th>ACTIONS</th>
              </tr>
            </thead>
          )}
          <tbody>
            {filteredUsers.map((user) => {
              if (!isMobile) {
                return (
                  <tr key={user._id}>
                    <td>{user._id}</td>
                    <td>{[(user.firstName||''), (user.lastName||'')].filter(Boolean).join(' ')}</td>
                    <td>{user.username}</td>
                    <td>
                      <a href={`mailto:${user.email}`}>{user.email}</a>
                    </td>
                    <td>
                      {user.isAdmin ? (
                        <i className='fas fa-check' style={{ color: 'green' }}></i>
                      ) : (
                        <i className='fas fa-times' style={{ color: 'red' }}></i>
                      )}
                    </td>
                    <td style={{ whiteSpace: 'nowrap' }}>
                      <LinkContainer to={`/admin/user/${user._id}/edit`}>
                        <Button variant='light' size='sm' className='me-1' aria-label='Edit user' title='Edit user'>
                          <i className='fas fa-edit'></i> Edit User
                        </Button>
                      </LinkContainer>
                      <Button
                        variant='danger'
                        size='sm'
                        aria-label='Delete user'
                        title='Delete user'
                        onClick={() => deleteHandler(user._id)}
                      >
                        <i className='fas fa-trash'></i> Delete User
                      </Button>
                    </td>
                  </tr>
                );
              }
              // Mobile card layout
              return (
                <tr key={user._id}>
                  <td data-label='Name' style={{ display: 'block' }}>
                    <div style={{ fontWeight: 600 }}>
                      {(user.firstName || '') + ' ' + (user.lastName || '')}
                      <span className='text-muted' style={{ marginLeft: 6, fontSize: '.8rem' }}>#{shortId(user._id)}</span>
                    </div>
                    <div className='text-muted' style={{ fontSize: '.75rem' }}>@{user.username}</div>
                  </td>
                  <td data-label='Email' style={{ display: 'block' }}>
                    {user.email ? <a href={`mailto:${user.email}`}>{user.email}</a> : <span className='text-muted'>-</span>}
                  </td>
                  <td data-label='Admin' style={{ display: 'block' }}>
                    {user.isAdmin ? (
                      <span><i className='fas fa-check' style={{ color: 'green', marginRight: 4 }}></i> Admin</span>
                    ) : (
                      <span><i className='fas fa-times' style={{ color: 'red', marginRight: 4 }}></i> User</span>
                    )}
                  </td>
                  <td data-label='Actions' style={{ display: 'block' }}>
                    <div style={{ display: 'flex', gap: '.5rem' }}>
                      <LinkContainer to={`/admin/user/${user._id}/edit`}>
                        <Button variant='light' className='btn-sm' aria-label='Edit user' title='Edit user'>
                          <i className='fas fa-edit'></i> Edit User
                        </Button>
                      </LinkContainer>
                      <Button
                        variant='danger'
                        className='btn-sm'
                        aria-label='Delete user'
                        title='Delete user'
                        onClick={() => deleteHandler(user._id)}
                      >
                        <i className='fas fa-trash'></i> Delete User
                      </Button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      )}

      <StepUpPasswordModal
        show={pendingDeleteId !== null}
        title='Confirm account deletion'
        description='For your security, please re-enter your password to delete this account.'
        onCancel={() => setPendingDeleteId(null)}
        onConfirm={handleStepUpConfirm}
        loading={stepUpLoading}
        error={stepUpError}
      />
    </>
  );
};

export default UserListScreen;